/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { Box, Chip, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MeetingPeople from '../../assets/static_images/meeting.svg';
import FileIcon from '../../assets/static_images/fileicon.svg';
import PdfIcon from '../../assets/static_images/pdficon.svg';
import DownloadIcon from '../../assets/static_images/downloadicon.svg';
import axios from 'lib/axios';
import FileDownload from 'js-file-download';
import UserAvatarComponent from 'components/UserAvatarComponent';
import { FiX } from 'react-icons/fi';

const getOrganizationTitle = (user) => {
    const jobTitle = user?.job_title;
    if (Array.isArray(jobTitle)) {
        return jobTitle[0]?.title || 'N/A';
    }
    return jobTitle?.title || 'N/A';
};

const sectionLabelSx = {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    mb: 1
};

const MeetingDetails = ({ meeting, setOpenDetails, heighLiter, closeMeeting, setCloseMeeting, setMeetings }) => {
    const [dateTime, setDateTime] = useState(() => {
        let date = `${new Date(meeting.meeting_date).toString()?.split(' ')[1]} ${
            new Date(meeting.meeting_date).toString()?.split(' ')[2]
        } ${new Date(meeting.meeting_date).toString()?.split(' ')[3]}
        `;
        var hours = new Date(meeting.meeting_date).getHours();
        var minutes = new Date(meeting.meeting_date).getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return `${date} ${strTime}`;
    });
    const pdfInput = useRef(null);
    const theme = useTheme();
    const [postPdfs, setPostPdfs] = useState([]);

    const [postPdfNames, setPostPdfNames] = useState([]);
    const [postPdfsData, setPostPdfsData] = useState([]);
    const [coordinator, setCoordinator] = useState();
    const [resolution, setResolution] = useState('');
    const [isClosed, setIsClosed] = useState(false);
    const [meetingResolutions, setMeetingResolutions] = useState(() => {
        return meeting?.resolutions ? meeting.resolutions : '';
    });
    const [meetingFileNames, setMeetingFileNames] = useState(() => {
        return meeting?.file_names ? meeting.file_names : '';
    });
    const [participants, setParticipants] = useState(() => {
        return [
            ...meeting.meeting_users.filter((user) => {
                if (user.is_coordinator) {
                    setCoordinator(user);
                } else {
                    return user;
                }
            })
        ];
    });

    async function convertPdf() {
        if (pdfInput.current.files[0].size < 52453290) {
            const file = pdfInput.current.files[0];
            const url = URL.createObjectURL(pdfInput.current.files[0]);
            setPostPdfsData([...postPdfsData, file]);
            setPostPdfs([...postPdfs, url]);
            setPostPdfNames([...postPdfNames, pdfInput.current.files[0].name]);
        } else {
            alert('Size Must Be Smaller Than 50MB');
        }
    }

    async function close_meeting() {
        const formData = new FormData();
        formData.append('meeting_id', meeting.meeting_id);
        formData.append('resolutions', resolution);
        postPdfsData.forEach((pdf, index) => {
            formData.append(`docs-${index}`, pdf);
        });
        try {
            const { data } = await axios.post('/meetings/close-meeting', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (data.success) {
                const updatedMeeting = data.meeting;
                if (updatedMeeting.resolutions) {
                    setMeetingResolutions(updatedMeeting.resolutions);
                }
                if (updatedMeeting.file_names?.length) {
                    setMeetingFileNames(updatedMeeting.file_names);
                }
                setIsClosed(true);
                setCloseMeeting?.(false);
                setOpenDetails(false);
                if (setMeetings) {
                    setMeetings((meetings) =>
                        meetings.map((item) => (item.meeting_id === updatedMeeting.meeting_id ? updatedMeeting : item))
                    );
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    async function download_file(path) {
        try {
            const response = await axios({
                url: `${path}`,
                method: 'GET',
                responseType: 'blob'
            });
            const filename = path.split('/').pop();
            FileDownload(response.data, filename);
        } catch (err) {
            console.log('Error downloading file:', err);
        }
    }

    const handleClose = () => {
        setCloseMeeting?.(false);
        setOpenDetails(false);
    };

    return (
        <Modal
            open={true}
            onClose={handleClose}
            aria-labelledby="meeting-details-modal"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                outline: 'none',
                background: 'rgba(0, 0, 0, 0.45)',
                backdropFilter: 'blur(4px)',
                p: 2
            }}
        >
            <Card
                sx={{
                    width: { xs: '96%', sm: '90%', md: '60%', lg: '52%' },
                    maxHeight: '92vh',
                    position: 'relative',
                    borderRadius: 3,
                    boxShadow: '0 16px 48px rgba(15, 23, 42, 0.16)',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    outline: 'none',
                    overflow: 'hidden'
                }}
            >
                {/* Fixed Header */}
                <Box
                    sx={{
                        px: { xs: 2.5, md: 3.5 },
                        py: 2.5,
                        borderBottom: '1px solid #E2E8F0',
                        position: 'relative',
                        backgroundColor: '#FAFBFC'
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            color: 'text.secondary',
                            bgcolor: 'grey.100',
                            borderRadius: '50%',
                            '&:hover': { bgcolor: 'grey.300' },
                            zIndex: 2
                        }}
                        size="small"
                    >
                        <FiX size={17} />
                    </IconButton>
                    <Box display="flex" alignItems="center" gap={1.5} pr={5}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'primary.lighter',
                                border: '1px solid',
                                borderColor: 'primary.light'
                            }}
                        >
                            <img src={MeetingPeople} alt="meeting" width={22} height={22} />
                        </Box>
                        <Typography color="primary" sx={{ fontWeight: 700, fontSize: { xs: '1.25rem', md: '1.4rem' } }}>
                            Meeting Details
                        </Typography>
                    </Box>
                </Box>

                {/* Scrollable Content */}
                <Box
                    sx={{
                        px: { xs: 2.5, md: 3.5 },
                        py: { xs: 2.5, md: 3 },
                        overflowY: 'auto',
                        flex: 1
                    }}
                >
                    <Box sx={{ mb: 3 }}>
                        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} mb={0.5}>
                            <Typography sx={{ fontSize: { xs: '1.15rem', md: '1.3rem' }, fontWeight: 650 }} color={heighLiter}>
                                {meeting.title}
                            </Typography>
                            <Chip
                                label={meeting.is_formal ? 'Formal' : 'Informal'}
                                size="small"
                                sx={{
                                    height: 24,
                                    fontWeight: 500,
                                    fontSize: '0.75rem',
                                    backgroundColor: meeting.is_formal ? 'primary.lighter' : '#F1F5F9',
                                    color: meeting.is_formal ? 'primary.main' : '#475569'
                                }}
                            />
                        </Stack>
                    </Box>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                            gap: 2,
                            mb: 3,
                            p: 2,
                            borderRadius: 2,
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #E2E8F0'
                        }}
                    >
                        <Box>
                            <Typography sx={sectionLabelSx}>Date & Time</Typography>
                            <Typography sx={{ fontWeight: 600, color: heighLiter || '#1E293B' }}>{dateTime}</Typography>
                        </Box>
                        <Box>
                            <Typography sx={sectionLabelSx}>Duration</Typography>
                            <Typography sx={{ fontWeight: 600, color: heighLiter || '#1E293B' }}>{meeting.meeting_duration}</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography sx={sectionLabelSx}>Meeting Coordinator</Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                p: 1.5,
                                borderRadius: 2,
                                border: '1px solid #E2E8F0',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <UserAvatarComponent userData={coordinator?.user} />
                            <Box>
                                <Typography sx={{ fontWeight: 600, color: '#1E293B' }}>
                                    {coordinator?.user.first_name}
                                    {` `}
                                    {coordinator?.user.last_name}
                                </Typography>
                                <Typography sx={{ fontSize: '0.875rem', color: '#64748B' }}>
                                    {getOrganizationTitle(coordinator?.user)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography sx={sectionLabelSx}>Participants</Typography>
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                gap: 1.5
                            }}
                        >
                            {participants?.map((participant, index) => {
                                return (
                                    <Box
                                        key={`parti-${participant.id}-${index}`}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.25,
                                            p: 1.25,
                                            borderRadius: 2,
                                            border: '1px solid #F1F5F9',
                                            backgroundColor: '#FAFBFC'
                                        }}
                                    >
                                        <UserAvatarComponent userData={participant?.user} />
                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography sx={{ fontWeight: 600, color: '#1E293B' }} noWrap>
                                                {participant?.user.first_name}
                                                {` `}
                                                {participant?.user.last_name}
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.8rem', color: '#64748B' }} noWrap>
                                                {getOrganizationTitle(participant?.user)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography sx={sectionLabelSx}>Agenda</Typography>
                        <Typography sx={{ color: '#475569', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{meeting.agenda}</Typography>
                    </Box>

                    {meetingResolutions ? (
                        <Box sx={{ mb: 3 }}>
                            <Typography sx={sectionLabelSx}>Resolutions</Typography>
                            <Typography sx={{ color: '#475569', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{meetingResolutions}</Typography>
                        </Box>
                    ) : (
                        <></>
                    )}

                    {meetingFileNames ? (
                        <Box sx={{ mb: 1 }}>
                            <Typography sx={sectionLabelSx}>Resolutions/Minutes</Typography>
                            <Typography sx={{ color: '#475569', lineHeight: 1.6, mb: 1.5, whiteSpace: 'pre-wrap' }}>
                                {meetingResolutions}
                            </Typography>
                            <Stack spacing={1}>
                                {meetingFileNames &&
                                    meetingFileNames?.map((reqfile, index) => {
                                        return (
                                            <Box
                                                key={`file-${index}`}
                                                onClick={() => {
                                                    download_file(reqfile.url || `./Uploads/Meeting/${meeting.meeting_id}/${reqfile.name}`);
                                                }}
                                                className="cursor-pointer"
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    gap: 1.5,
                                                    p: 1.25,
                                                    borderRadius: 2,
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    transition: 'background-color 0.15s ease',
                                                    '&:hover': {
                                                        backgroundColor: '#F8FAFC'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
                                                    <img src={FileIcon} alt="file" width={20} height={20} />
                                                    <Typography sx={{ color: '#334155' }} noWrap>
                                                        {reqfile.name}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.75,
                                                        px: 1.25,
                                                        py: 0.75,
                                                        borderRadius: 1.5,
                                                        backgroundColor: '#F1F5F9',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    <img src={DownloadIcon} alt="downicon" width={14} height={14} />
                                                    <Typography sx={{ fontSize: '0.8rem', color: '#64748B', fontWeight: 500 }}>
                                                        Download
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                            </Stack>
                        </Box>
                    ) : (
                        <></>
                    )}
                </Box>

                {/* close meeting */}
                {closeMeeting && !isClosed && !meeting.is_closed && (
                    <Box
                        sx={{
                            borderTop: '1px solid #E2E8F0',
                            px: { xs: 2.5, md: 3.5 },
                            py: { xs: 2.5, md: 3 },
                            backgroundColor: '#F8FAFC'
                        }}
                    >
                        <Box sx={{ mb: 2.5 }}>
                            <Typography sx={{ ...sectionLabelSx, mb: 1.25 }}>Resolution</Typography>
                            <textarea
                                placeholder="Type Here ..."
                                onChange={(e) => {
                                    setResolution(e.target.value);
                                }}
                                rows="3"
                                cols="100"
                                style={{
                                    width: '100%',
                                    minHeight: '100px',
                                    padding: '14px',
                                    borderRadius: '8px',
                                    border: '1px solid #E2E8F0',
                                    background: '#FFFFFF',
                                    fontFamily: 'inherit',
                                    fontSize: '1rem',
                                    resize: 'vertical',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                value={resolution}
                            ></textarea>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography sx={{ ...sectionLabelSx, mb: 1.25 }}>Attach Files</Typography>
                            {postPdfs.length > 0 ? (
                                <Stack spacing={1} sx={{ mb: 1.5 }}>
                                    {postPdfs.map((pdf, index) => {
                                        return (
                                            <Box
                                                key={`img@${index}`}
                                                sx={{
                                                    position: 'relative',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    p: 1.25,
                                                    borderRadius: 2,
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                                className="img-box"
                                            >
                                                <img src={PdfIcon} width={28} height={28} alt="pdficon" />
                                                <Typography
                                                    className="cursor-pointer"
                                                    sx={{ fontSize: '0.95rem', color: '#334155', flex: 1, minWidth: 0 }}
                                                    noWrap
                                                    onClick={() => {
                                                        window.open(pdf, '_blank', 'fullscreen=yes');
                                                        return false;
                                                    }}
                                                >
                                                    {postPdfNames[index]}
                                                </Typography>
                                                <Box
                                                    onClick={() => {
                                                        setPostPdfs((postPdfs) => {
                                                            let temp = [...postPdfs];
                                                            temp.splice(index, 1);
                                                            return temp;
                                                        });
                                                        setPostPdfNames((postPdfNames) => {
                                                            let temp = [...postPdfNames];
                                                            temp.splice(index, 1);
                                                            return temp;
                                                        });

                                                        setTimeout(() => {
                                                            pdfInput.current.focus();
                                                        }, 0.5);
                                                    }}
                                                    display="flex"
                                                    direction="column"
                                                    justifyContent="start"
                                                    alignItems="start"
                                                    sx={{
                                                        opacity: 0.7,
                                                        '&:hover': { opacity: 1 }
                                                    }}
                                                    className="trash cursor-pointer"
                                                >
                                                    <Badge color="primary" badgeContent={'X'} sx={{ marginLeft: 'auto' }}></Badge>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Stack>
                            ) : (
                                <Box
                                    className="dashed"
                                    sx={{
                                        position: 'relative',
                                        padding: '1.5rem',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        border: '2px dashed #E2E8F0',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        '&:hover': {
                                            backgroundColor: '#F1F5F9',
                                            borderColor: '#CBD5E1'
                                        }
                                    }}
                                >
                                    <Badge
                                        color="primary"
                                        className="float-end cursor-pointer"
                                        badgeContent={'X'}
                                        onClick={() => {
                                            setOpenPdfUploader(false);
                                        }}
                                        sx={{ position: 'absolute', top: 8, right: 8 }}
                                    ></Badge>
                                    <Box
                                        className="cursor-pointer"
                                        onClick={() => pdfInput.current.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1,
                                            py: 0.5
                                        }}
                                    >
                                        <img src={FileIcon} alt="logo" width={24} height={24} />
                                        <Typography sx={{ fontSize: '15px', fontWeight: 500 }} color="primary">
                                            Upload a file
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                            {postPdfs.length > 0 ? (
                                <Box sx={{ backgroundColor: `${theme.palette.primary.lighter}`, borderRadius: 1, mb: 1 }}>
                                    <Button
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        sx={{ backgroundColor: 'primary' }}
                                        className="cursor-pointer"
                                        onClick={() => {
                                            pdfInput.current.click();
                                        }}
                                    >
                                        <Typography variant="h6">+ FILES </Typography>
                                    </Button>
                                </Box>
                            ) : (
                                <></>
                            )}
                            <div style={{ display: 'none' }}>
                                <input
                                    ref={pdfInput}
                                    type="file"
                                    // accept=".pdf"
                                    name="pdfInput"
                                    onChange={convertPdf}
                                    className="hidden"
                                />
                            </div>
                        </Box>

                        <Button
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            className="cursor-pointer"
                            onClick={() => {
                                close_meeting();
                            }}
                            sx={{
                                background: '#0FC66A',
                                borderRadius: 1.5,
                                fontWeight: 600,
                                py: 1.25,
                                boxShadow: 'none',
                                '&:hover': {
                                    background: '#0BA855',
                                    boxShadow: 'none'
                                }
                            }}
                        >
                            <Typography variant="h6">Close Meeting</Typography>
                        </Button>
                    </Box>
                )}
            </Card>
        </Modal>
    );
};

export default MeetingDetails;
